import { ResourceOptions } from 'react-admin';
import { MdVpnLock } from 'react-icons/md';
import './dataProvider';
import { Resources } from '../resource';

export { default as list } from './ProxyManagerPage';

export const name = Resources.proxyManager;
export const icon = MdVpnLock;
export const options: ResourceOptions = {
  label: 'resource.proxyManager',
};
